class NetworkError {
    constructor() {
        this.messsage = "Network error";
    }
}

export default NetworkError;
